import ClickItUserShow from "./clickItUserShow";
import ClickItUserList from "./clickItUserList";
import ClickItUserEdit from "./clickItUserEdit";

export default {
  show: ClickItUserShow,
  list: ClickItUserList,
  edit: ClickItUserEdit,
};
